import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAccessToken, getRole } from '@/assets/js/auth'

import Auth from './modules/Auth'
import packages from './modules/package'
import customer from './modules/customer'
import employee from './modules/employee'
import accountSuperAdmin from './modules/accountSuperAdmin'
import dashboard from './modules/dashboard'
import statement from './modules/statement'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: () => {
      const role = getRole()
      switch (role) {
        case 'SUPER_ADMIN':
          return { name: 'DashBoard' }
        case 'ADMIN':
          return { name: 'SalesReport' }
        default:
          return { name: 'DashBoard' }
      }
    },
    meta: {
      auth: true
    }
  },
  Auth,
  dashboard,
  statement,
  accountSuperAdmin,
  packages,
  customer,
  employee,

  {
    path: '/*',
    name: 'PageNotFound',
    component: () => import('@/views/errorPage/404.vue'),
    meta: {
      layout: 'Blank'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = getAccessToken()
  const userRole = getRole()
  if (to.meta?.auth && !token) {
    return router.replace({ name: 'LogoutPage' })
  }

  if (token && to.name === 'LoginPage') {
    return router.replace({ name: 'DashBoard' })
  }

  if (to.meta?.role && to.meta.role !== userRole) {
    return router.replace({ name: 'SalesReport' })
  }
  // if (to.meta?.auth) {
  //   if (!token) {
  //     return router.replace({ name: 'LogoutPage' })
  //   }
  // }
  // if (token && to.name === 'LoginPage') {
  //   return router.replace({ name: 'DashBoard' })
  // }
  return next()
})

export default router
